// Информация для формы - Оплата (каналы)
export const PAY_CHANNEL_DETAIL = "PAY_CHANNEL_DETAIL";

// Покупка каналов
export const PAY_CHANNEL = "PAY_CHANNEL";

// Пополнение
export const PAY_BALANCE = "PAY_BALANCE";

// Успешное пополнение
export const PAY_SUCCESS = "PAY_SUCCESS";

// Оплата не прошла
export const PAY_FAIL = "PAY_FAIL";

// Количество активированных каналов
export const PAY_ACTIVATED_CHANNELS = "PAY_ACTIVATED_CHANNELS";

// Количество активированных каналов
export const PAY_GET_BALANCE = "PAY_GET_BALANCE";

// История покупок
export const PAY_HISTORY = "PAY_HISTORY";

// Покупка опций
export const PAY_OPTIONS = "PAY_OPTIONS";

// Покупка опций прошла успешно
export const PAY_OPTIONS_SUCCESS = "PAY_OPTIONS_SUCCESS";

// Связь опций с инстансом
export const PAY_OPTIONS_LNK_INSTANCE = "PAY_OPTIONS_LNK_INSTANCE";

// Автопродление опции (для checkbox)
export const AUTO_RENEWAL_OPTION = "AUTO_RENEWAL_OPTION";

// Продление опций
export const PAY_OPTIONS_RENEWAL = "PAY_OPTIONS_RENEWAL";
